"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPreview = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const helper_1 = require("./helper");
const Spotify_1 = require("./Spotify");
const AppleMusic_1 = require("./AppleMusic");
const AudioPreview = ({ url }) => {
    const link = helper_1.getAudioLink(url);
    if (!link) {
        return null;
    }
    if (link.type === 'spotify') {
        const { type, id } = link.link;
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(Spotify_1.Spotify, { type: type, id: id })));
    }
    if (link.type === 'apple_music') {
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(AppleMusic_1.AppleMusic, { url: link.link })));
    }
    return null;
};
exports.AudioPreview = AudioPreview;
